import { useSelector } from "react-redux";
import { RootState } from "../../../../core/store/store";
import { TextComponent } from "../../../../core/components/TextComponent";
import { Select } from "../../../../core/components/Select";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { SettingsDetailsFormValues, settingsDetailsValidationSchema } from "../interface/SettingsFormInterface";
import { useDebouncedConfig } from "../hook/useDebounceConfig";

export const SearchSettings = () => {
	const { getProfileConfig } = useSelector((state: RootState) => state.onboarding);
	const { showMeList } = useSelector((state: RootState) => state.onboarding);
	const initialValues: SettingsDetailsFormValues = {
		showMe: getProfileConfig?.user_has_showme.map((sh) => sh.showme_id) || [],
	};
	const customConditions = (debounceValue: typeof initialValues, initialValues: SettingsDetailsFormValues) => {
		if (debounceValue.showMe.length === 0) return true;
		if (JSON.stringify([...debounceValue.showMe].sort()) === JSON.stringify([...initialValues.showMe].sort())) return true;
		return false;
	};
	const [userShowMe, setUserShowMe] = useDebouncedConfig<SettingsDetailsFormValues>({
		initialValues,
		buildUpdatedFilters: (settings) => ({
			showme: settings.showMe,
		}),
		customConditions,
	});

	return (
		<>
			<Formik
				initialValues={initialValues}
				validationSchema={settingsDetailsValidationSchema}
				onSubmit={() => {}}
			>
				{({ handleBlur, setFieldValue }) => (
					<Form className="flex flex-col gap-4">
						<TextComponent
							variant="h2"
							className="font-semibold mt-7"
						>
							Search settings
						</TextComponent>
						<div className="w-3/4">
							<Field
								as={Select}
								id="showMe"
								name="showMe"
								selectionMode="multiple"
								label="Show me"
								items={showMeList.map((e) => ({ key: e.id, label: e.name }))}
								value={userShowMe.showMe}
								onChange={(e: any) => {
									setUserShowMe({ showMe: e.target.value });
									setFieldValue("showMe", e.target.value);
								}}
								onBlur={handleBlur}
								required
							/>
							<ErrorMessage
								name="showMe"
								component="div"
								className="text-red-500 text-xs"
							/>
						</div>
					</Form>
				)}
			</Formik>
		</>
	);
};
